import * as contributionLib from "@taabl/common-lib/calculators/contribution";
import * as dateLib from "@taabl/common-lib/calculators/date";
import * as moneyLib from "@taabl/common-lib/calculators/money";
import * as common from "@taabl/common-lib/utils";
import moment from "moment";
import { Constants } from "./Constants";

export function getQueryParams(location) {
  let qp = {};
  if (location) {
    if (location.startsWith("?")) {
      location = location.substring(1);
    }
    let params = location.split("&");
    for (let p of params) {
      let keyValue = p.split("=");
      if (keyValue && keyValue.length === 2) {
        qp[keyValue[0]] = decodeURIComponent(keyValue[1]);
      }
    }

    return qp;
  }
  return qp;
}

export const convertDate = dateLib.convertDate;

export const formatDate = dateLib.formatDate;

export const getValidDate = dateLib.getValidDate;

export const getCurrentDate = dateLib.getCurrentDate;

export const round = common.round;

export const roundToDigit = common.roundToDigit;

export const numberWithCommas = moneyLib.numberWithCommas;

export const getDetailsFromKey = common.getDetailsFromKey;

export const formatCurrency = moneyLib.formatCurrency;

export const convertToDollar = moneyLib.convertToDollar;

export const convertToCents = moneyLib.convertToCents;

export const constructPeriodForDisplay = dateLib.constructPeriodForDisplay;

export const convertCellForExcel = common.convertCellForExcel;

export const groupBy = common.groupBy;

export const convertCellWithForumlaForExcel =
  common.convertCellWithForumlaForExcel;

export const getNextColumnForExcel = common.getNextColumnForExcel;

export const incrementColumnForExcel = common.incrementColumnForExcel;

export const checkForNumbers = common.checkForNumbers;

export const checkForSymbols = common.checkForSymbols;

export const checkForUpperCase = common.checkForUpperCase;

export const checkForLowerCase = common.checkForLowerCase;

export const generatePassword = common.generatePassword;

export const calculateMaxContribution =
  contributionLib.calculateMaxContribution;
const Colors = {
  darkred: "#8b0000",
  darkorange: "#ff8c00",
  aqua: "#00ffff",
  black: "#000000",
  olive: "#808000",
  red: "#ff0000",
  gold: "#ffd700",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgrey: "#a9a9a9",
  darkgreen: "#006400",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorchid: "#9932cc",
  darksalmon: "#e9967a",
  darkviolet: "#9400d3",
  fuchsia: "#ff00ff",
  indigo: "#4b0082",
  lightblue: "#add8e6",
  lightgreen: "#90ee90",
  lime: "#00ff00",
  magenta: "#ff00ff",
  maroon: "#800000",
};
export function generateRandomRGBColor(dark = false, index = 0) {
  if (!dark) {
    let r = Math.floor(Math.random() * 255);
    let g = Math.floor(Math.random() * 255);
    let b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  } else {
    let colorNames = Object.keys(Colors);
    if (index > colorNames.length - 1) {
      index = 0;
    }
    return Colors[colorNames[index]];
  }
}

// This function tell whether contribution is done by taabl or user
export const isParticipating = contributionLib.isParticipating;

export const convertUTCDateInTimeZone = dateLib.convertUTCDateInTimeZone;

export const checkIfValidDate = (value) => {
  let datevalidity = moment(
    value,
    [
      Constants.DATEFORMAT.MMDDYYYY,
      Constants.DATEFORMAT.MDDYYYY,
      Constants.DATEFORMAT.MMDYYYY,
      Constants.DATEFORMAT.MDYYYY,
    ],
    true
  );
  return datevalidity.isValid();
};
export const formatCase = (input) => {
  const result = input.replace(/([A-Z])/g, " $1");
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};

/**
 * @param  {string} contributionValue
 * @param  {number} purchasePeriod
 */
export function calculateBimonthlyPay(contributionValue, purchasePeriod) {
  return contributionValue / (purchasePeriod * 2);
};